export const createApiBaseQuery =
  (apiClient) =>
  async ({ url, method, data }) => {
    const providedMethod = method.toLowerCase();
    const allowedMethods = ['get', 'post', 'put', 'patch', 'delete'];

    if (!allowedMethods.includes(providedMethod)) {
      throw new Error('Invalid method called on the base query');
    }

    try {
      const response = await apiClient[providedMethod](url, data);
      return { data: response.data };
    } catch (err) {
      return {
        error: { status: err.response.status, data: err.response.data },
      };
    }
  };
